angular.module('vehicle-issue')
    .service('VehicleIssueService', function (modals, $rootScope, VehicleIssue, VehicleIssueConst) {
        this.addIssue = (booking, vehicle) => {
            let entity = {
                id: null,
                priority: 'LOW',
                booking: booking,
                vehicle: vehicle
            }
            modals.open(VehicleIssueConst.tpl + 'issue-modal.html', 'VehicleIssueEditController', angular.copy(entity), {size: 'md'}, "$ctrl")
        }
        this.toggleIssueStatus = (issue) => {
            VehicleIssue.toggle({id: issue.vehicle.id, issueId: issue.id}, issue).$promise.then(() => $rootScope.$broadcast(VehicleIssueConst.eventUpdate))
        }
        this.delete = (issue) => {
            modals.confirmDelete("wpis id=" + issue.id, () => VehicleIssue.delete({id: issue.vehicle.id, issueId: issue.id}).$promise.then(() => $rootScope.$broadcast(VehicleIssueConst.eventUpdate)));
        }
    })
